import { Link } from 'react-router'
import { RiArrowRightLine, RiMapPin2Line } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import heroImage from '@/assets/images/Home Page Image .png'

export const HeroSection = () => (
  <section className="relative min-h-screen bg-base-900 flex flex-col overflow-hidden">
    {/* ── Background image ── */}
    <div className="absolute inset-0 z-0">
      <img
        src={heroImage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover object-[65%_center]"
      />
      {/* Warm dark overlay — hides watermark, image still felt in background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(105deg, rgba(40,12,12,0.88) 0%, rgba(40,12,12,0.82) 55%, rgba(40,12,12,0.75) 100%)',
        }}
      />
    </div>

    {/* ── Content ── */}
    <div className="relative z-10 flex-1 flex items-center">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-20 w-full">
        <div className="max-w-[560px] py-20 lg:py-36 mx-auto lg:mx-0 space-y-6 text-center lg:text-left">
          {/* Headline */}
          <h1
            className="font-display font-bold text-white leading-[1.0] tracking-tight animate-fade-in-up"
            style={{ fontSize: 'clamp(3.5rem, 9vw, 7.5rem)', animationDelay: '0.2s' }}
          >
            <em className="not-italic text-white">Healing</em>
            <br />
            <em className="not-italic italic text-gold-400">Empowerment</em>
            <br />
            <em className="not-italic text-white">Restoration</em>
          </h1>

          {/* Accent */}
          <div
            className="w-14 h-[3px] rounded-full bg-gradient-to-r from-gold-400 to-crimson-400 mx-auto lg:mx-0 animate-fade-in"
            style={{ animationDelay: '0.35s' }}
          />

          {/* Tagline */}
          <p
            className="font-display text-lg lg:text-[1.3rem] italic text-white/80 leading-relaxed animate-fade-in-up"
            style={{ animationDelay: '0.42s' }}
          >
            Where Healing Begins, Empowerment Grows, and Restoration Follows.
          </p>

          {/* Body */}
          <p
            className="text-[14.5px] text-white/70 leading-[1.9] max-w-[440px] mx-auto lg:mx-0 animate-fade-in-up"
            style={{ animationDelay: '0.5s' }}
          >
            A space to gently support you through pregnancy and early parenthood — so you feel
            informed, held, and deeply supported every step of the way.
          </p>

          {/* CTAs */}
          <div
            className="flex flex-wrap items-center justify-center lg:justify-start gap-3 pt-1 animate-fade-in-up"
            style={{ animationDelay: '0.6s' }}
          >
            <Link to={ROUTES.ENQUIRY} className="btn-primary">
              Begin Your Journey
              <RiArrowRightLine size={18} />
            </Link>
            <Link
              to={ROUTES.SERVICES}
              className="inline-flex items-center gap-2 border border-white/50 hover:border-white text-white hover:bg-white/10 font-semibold text-[14px] px-6 py-3 rounded-full transition-all duration-200"
            >
              Explore Services
              <RiArrowRightLine size={17} />
            </Link>
          </div>

          {/* Location */}
          <div
            className="flex items-center justify-center lg:justify-start gap-2 animate-fade-in"
            style={{ animationDelay: '0.7s' }}
          >
            <RiMapPin2Line size={12} className="text-gold-400 shrink-0" />
            <p className="text-[10.5px] text-white/60 uppercase tracking-[0.2em] font-medium">
              Essex · North Kent · East London
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* ── Trust strip ── */}
    <div
      className="relative z-10 bg-crimson-950/90 backdrop-blur-md border-t border-crimson-800 animate-fade-in-up"
      style={{ animationDelay: '0.85s' }}
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-3 divide-x divide-crimson-800">
          {[
            { value: '15+', label: 'Years in Advocacy & Support' },
            { value: '4', label: 'Tailored Birth Keeper Services' },
            { value: 'Free', label: 'Initial Support Call with Simone' },
          ].map(({ value, label }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center py-6 px-3 gap-1.5"
            >
              <span className="font-display text-2xl font-bold leading-none text-gold-400">
                {value}
              </span>
              <span className="text-[11px] text-white/60 font-medium text-center uppercase tracking-[0.14em] leading-snug">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
)
